import React from 'react';
import Helmet from 'react-helmet';

import { MANUAL_CONTACT_TAB } from '../utilities/constants';
import _masterSlideLoader from '../utilities/masterSlideLoader';
import { NoticeFromBuildee } from '../components/ManualContact/page/NoticeFromBuildee';
import { getNameManualContact } from '../utilities/constantsUtil';

import styles from '../styles/componentStyle/ManualContact/manual-contact.scss';
import _urlParamManager from '../utilities/urlParamManager';
import { MasterPageHeader } from '../components/PageHeader';

/**
 * マニュアル・お問い合わせ 画面
 */
export class ManualContact extends React.Component {
  defaultState = {
    selectedTabId: MANUAL_CONTACT_TAB.MANUAL.ID,
  };

  constructor(props) {
    super(props);

    this.state = this.defaultState;

    if (![MANUAL_CONTACT_TAB.NOTICE.ID].includes(props.view.state.id)) {
      throw new Error('ManualContact.jsx constructor this.props.selectedTabId');
    }
    this.state.selectedTabId = props.view.state.id;
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.view.state.id !== this.props.view.state.id) {
      // props指定でタブ切替が行われる場合はタブを切り替える
      this.setState({ selectedTabId: this.props.view.state.id });
    } else {
      // stateでのタブ切替ではないにも関わらず
      // 選択タブとprops指定タブ切替が異なる場合には、
      // propsからの呼び出しなのでタブを切り替える
      if (prevState.selectedTabId === this.state.selectedTabId) {
        if (this.state.selectedTabId !== this.props.view.state.id) {
          this.setState({ selectedTabId: this.props.view.state.id });
        }
      }
    }
  }

  /**
   * タブ切り替え
   */
  onClickTabItem = (e, tabId) => {
    if (this.state.selectedTabId !== tabId) {
      _urlParamManager.setMaster('ManualContact', {
        state: {
          id: tabId,
        },
      });
      this.setState({ selectedTabId: tabId });
    }
  };

  renderTabContent = selectedTabId => {
    switch (selectedTabId) {
      case MANUAL_CONTACT_TAB.NOTICE.ID:
        return <NoticeFromBuildee />;
      default:
        return null;
    }
  };

  render() {
    return (
      <div className={`${styles.manualContact} contruction-slide-view show`}>
        <div className='contruction-slide-view__view'>
          <Helmet>
            <title>調整会議 - Buildeeからのお知らせ</title>
          </Helmet>
          <MasterPageHeader
            title={getNameManualContact(this.state.selectedTabId)}
            onClose={() => _masterSlideLoader.close()}
          />

          <div className='contruction-slide-view__body'>
            <div className='contruction-detail-view'>
              <div className='contruction-detail-view__body'>
                {this.renderTabContent(this.state.selectedTabId)}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ManualContact.jsx